import React from "react";
import {GlobalAccordionStyled} from "./styled/GlobalAccordionStyled";
import {GlobalStyled} from "./styled/GlobalStyled";
import {GlobalModalStyled} from "./styled/GlobalModalStyled";
import {GlobalOverlaysStyled} from "./styled/GlobalOverlaysStyled";
import {GlobalAlertsStyled} from "./styled/GlobalAlertsStyled";
import {GlobalFormsStyled} from "./styled/GlobalFormsStyled";
import {GlobalDatePickerStyled} from "./styled/GlobalDatePickerStyled";
import {GlobalNotificationsStyled} from "./styled/GlobalNotificationsStyled";
import {GlobalUtilsStyled} from "./styled/GlobalUtilsStyled";
import { GlobalButtonsStyled } from "./styled/GlobalButtonsStyled";

export const GlobalStyles = () => (
        <>
            <GlobalStyled/>
            <GlobalAccordionStyled/>
            <GlobalAlertsStyled/>
            <GlobalButtonsStyled/>
            <GlobalDatePickerStyled/>
            <GlobalFormsStyled/>
            <GlobalModalStyled/>
            <GlobalNotificationsStyled/>
            <GlobalOverlaysStyled/>
            <GlobalUtilsStyled/>
        </>
);